module.exports = __webpack_public_path__ + "static/avg-300x118-36ad15545b5512145195a423d639be42.png";